import React, { ComponentProps, FC, MouseEvent } from 'react';
import { SproutButton } from 'components/Button/SproutButton';
import { ContentLink, IContentLinkProps } from 'components/ContentLink/ContentLink';
import { isEntry } from 'utils/EntryUtil';

type SproutButtonProps = ComponentProps<typeof SproutButton>;

export const ButtonLink: FC<IContentLinkProps> = ({ tabIndex, ...props }) => {
  if (!isEntry(props.entry)) return null;

  const variant = (props.entry?.fields as SproutButtonProps)?.variant ?? 'primary';
  const isTextVariant = props.isTextVariant;

  return (
    <SproutButton variant={variant} onClick={onClick} tabIndex={tabIndex} isTextVariant={isTextVariant}>
      <ContentLink tabIndex={-1} {...props} />
    </SproutButton>
  );
};

function onClick(event: MouseEvent<HTMLButtonElement>) {
  const anchor = event.currentTarget.querySelector('a');
  anchor?.click();
}
